import React from 'react';
import { Route, Routes } from 'react-router-dom';
import AddNewPaymentMethod from '../pages/AddNewPaymentMethod/AddNewPaymentMethod';

const PageRoutes = () => (
  <Routes>
    <Route path='/' element={<AddNewPaymentMethod />} />
  </Routes>
);

export default PageRoutes;
